module.exports = __webpack_public_path__ + "img/hh2.e34fe30e.png";